import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRemoteUtilityId } from '@shared/selectors/globalSelectors';
import { useOperations } from '../hooks';
import { PageHeader } from '@shared/ui/pageHeader';
import { Tabs } from '@shared/ui/tabs';
import { Button } from '@shared/ui/button';
import { Plus, Clock, History } from 'lucide-react';
import { HistoryList } from './HistoryList';
import { PendingList } from './PendingList';

export const Landing = () => {
    const navigate = useNavigate();
    const utilityId = useRemoteUtilityId();
    const [searchParams] = useSearchParams();
    const currentTab = searchParams.get('tab') || 'pending';
    const { data: countsData } = useOperations(utilityId, currentTab);

    const tabComponents = {
        pending: {
            label: "Pending",
            shortLabel: "pending",
            count: countsData?.tabCounts?.pending ?? 0,
            countClassName: "bg-blue-100 text-blue-700 ml-2 rounded-full px-2 py-0.5 text-xs font-semibold",
            component: <PendingList />,
        },
        history: {
            label: "History",
            shortLabel: "history",
            count: countsData?.tabCounts?.history ?? 0,
            countClassName: "bg-blue-100 text-blue-700 ml-2 rounded-full px-2 py-0.5 text-xs font-semibold",
            component: <HistoryList />,
        },
    };

    const urlMapping = {
        pending: "pending",
        history: "history",
    };

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between w-full">
                <PageHeader
                    title="Operations"
                    description="Field operations including inspections, repairs, installations, and more."
                />
                <Button variant='default' onClick={() => navigate('/mx/operations/create')}>
                    <Plus className="w-4 h-4 mr-2" />
                    Add Operation
                </Button>
            </div>

            <div className="mt-6">
                <Tabs
                    defaultValue="pending"
                    urlMapping={urlMapping}
                    tabComponents={tabComponents}
                    tabsListClassName="grid grid-cols-2"
                />
            </div>
        </div>
    );
};
